<template>
  <hm-content title="">
    <div class="table-panel flex flex-end mt20">
      <div>
        <el-date-picker
          v-model="applyDateMark"
          type="datetimerange"
          align="right"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始时间段筛选"
          end-placeholder="结束时间段筛选"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
          clearable
        ></el-date-picker>
        <el-button type="primary" size="small" @click="searchMark"
          >查询</el-button
        >
      </div>
    </div>
    <div class="table-panel flex flex-start mt20">
      <div class="flex item-center">
        营销动态
      </div>
    </div>
    <div>
      <el-row :gutter="10">
        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" class="mb10"
          ><div class="grid-content bg-purple flex flex-center">
            <div class="flex-1 ccc">
              <img
                src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2080%402x.png"
                alt=""
              />
            </div>
            <div class="flex-1 ml10 pp20">
              <p class="tit">销量申报数</p>
              <p style="marginTop:10px;color: rgba(34,34,34,1);">
                <span class="titval"> {{ marketingDynamic.billCount }}</span>
                <span>笔</span>
              </p>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" class="mb10"
          ><div class="grid-content bg-purple flex flex-center">
            <div class="flex-1 ccc">
              <img
                src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2080%402x(1).png"
                alt=""
              />
            </div>
            <div class="flex-1 ml10 pp20">
              <p class="tit">导购提成额</p>
              <p style="marginTop:10px;color: rgba(34,34,34,1);">
                <span class="titval">
                  {{ marketingDynamic.guiderCommissionTotal }}</span
                >
                <span>元</span>
              </p>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" class="mb10"
          ><div class="grid-content bg-purple flex flex-wrap">
            <div class="flex-1 ccc">
              <img
                src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2080%402x.png"
                alt=""
              />
            </div>
            <div class="flex-1 ml10 pp20">
              <p class="tit">推订单数</p>
              <p style="marginTop:10px;color: rgba(34,34,34,1);">
                <span class="titval">
                  {{ marketingDynamic.shareOrderCount }}</span
                >单
              </p>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" class="mb10"
          ><div class="grid-content bg-purple flex flex-wrap">
            <div class="flex-1 ccc">
              <img
                src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2080%402x%20(1).png"
                alt=""
              />
            </div>
            <div class="flex-1 ml10 pp20">
              <p class="tit">推订单分佣</p>
              <p style="marginTop:10px;color: rgba(34,34,34,1);">
                <span class="titval">
                  {{ marketingDynamic.shareOrderCommissionTotal }}</span
                >元
              </p>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" class="mb10"
          ><div class="grid-content bg-purple flex flex-wrap">
            <div class="flex-1 ccc">
              <img
                src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2080%402x%20(2).png"
                alt=""
              />
            </div>
            <div class="flex-1 ml10 pp20">
              <p class="tit">提现笔数</p>
              <p style="marginTop:10px;color: rgba(34,34,34,1);">
                <span class="titval">
                  {{ marketingDynamic.guiderGetcashRecordCount }}</span
                >笔
              </p>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" class="mb10"
          ><div class="grid-content bg-purple flex flex-wrap">
            <div class="flex-1 ccc">
              <img
                src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2080%402x%20(3).png"
                alt=""
              />
            </div>
            <div class="flex-1 ml10 pp20">
              <p class="tit">提现金额</p>
              <p style="marginTop:10px;color: rgba(34,34,34,1);">
                <span class="titval">
                  {{ marketingDynamic.guiderGetcashRecordTotal }}</span
                >元
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="table-panel flex flex-start mt20">
      <div class="flex item-center">
        审核动态
      </div>
    </div>
    <div>
      <el-row :gutter="10">
        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" class="mb10"
          ><div
            class="grid-contents bg-purple flex flex-wrap xiaoliang pointer"
            @click="billWaitAuditCount('old')"
          >
            <div>
              <img
                src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2080%402x(5).png"
                alt=""
              />
            </div>
            <div class="flex-1 ml10">
              <p class="tit">销量申报待审核</p>
              <p style="marginTop:10px;color: rgba(255, 255, 255, 1);">
                <span class="titval">
                  {{ auditDynamic.billWaitAuditCount }}</span
                >
                <span>笔</span>
              </p>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" class="mb10"
          ><div
            class="grid-contents bg-purple flex flex-wrap quanshen pointer"
            @click="billWaitAuditCount('new')"
          >
            <div>
              <img
                src="https://imgcdn.hemiao100.com/hemiaoBase/quanshenImg.png"
                alt=""
              />
            </div>
            <div class="flex-1 ml10">
              <p class="tit">全审单待审核</p>
              <p style="marginTop:10px;color: rgba(255, 255, 255, 1);">
                <span class="titval">
                  {{ auditDynamic.newBillWaitAuditCount || 0 }}</span
                >
                <span>笔</span>
              </p>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" class="mb10"
          ><div
            class="grid-contents bg-purple flex flex-wrap daogou pointer"
            @click="brandGuiderWaitAuditCount"
          >
            <div>
              <img
                src="https://imgcdn.hemiao100.com/hemiaoBase/joinBrandImg.png"
                alt=""
              />
            </div>
            <div class="flex-1 ml10">
              <p class="tit">品牌加入待审核</p>
              <p style="marginTop:10px;color: rgba(255, 255, 255, 1);">
                <span class="titval">
                  {{ auditDynamic.brandGuiderWaitAuditCount }}</span
                >
                <span>位</span>
              </p>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" class="mb10"
          ><div
            class="grid-contents bg-purple flex flex-wrap tixian pointer"
            @click="guiderGetcashRecordWaitAuditCount"
          >
            <div>
              <img
                src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2080%402x(6).png"
                alt=""
              />
            </div>
            <div class="flex-1 ml10">
              <p class="tit">提现申请待审核</p>
              <p style="marginTop:10px;color: rgba(255, 255, 255, 1);">
                <span class="titval">
                  {{ auditDynamic.guiderGetcashRecordWaitAuditCount }}</span
                >
                <span>笔</span>
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="flex flex-center mt20">
      <div class="table flex-1">
        <div class="table-panel flex flex-between mt20">
          <div class="flex item-center">
            红包发放排名
          </div>
          <div>
            <el-date-picker
              v-model="applyDatesSend"
              type="datetimerange"
              align="right"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="开始时间段筛选"
              end-placeholder="结束时间段筛选"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              clearable
            ></el-date-picker>
            <el-button type="primary" size="small" @click="searchSend"
              >查询</el-button
            >
          </div>
        </div>
        <span class="form-tip">默认昨日排名</span>

        <el-table stripe border :data="sendRankingList" size="small">
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="主体名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="红包类型"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.storeType === 'supplier'">
                导购红包
              </div>
              <div v-else>
                分销红包
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="receiptCount"
            label="红包数量"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="commissionPriceSum"
            label="红包金额"
          >
            <template slot-scope="scope">
              <div class="primary" v-if="scope.row.commissionPriceSum">
                ¥{{ scope.row.commissionPriceSum }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="hm-pagination">
          <el-pagination
            background
            :total="sendRankingList.total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div> -->
      </div>
      <div class="flex-1">
        <div class="table-panel flex flex-between mt20">
          <div class="flex item-center">
            销售走势
          </div>
          <div>
            <el-date-picker
              v-model="applyDatesPacket"
              type="datetimerange"
              align="right"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="开始时间段筛选"
              end-placeholder="结束时间段筛选"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              clearable
            ></el-date-picker>
            <el-button type="primary" size="small" @click="search"
              >查询</el-button
            >
          </div>
        </div>
        <el-radio-group
          v-model="useImmediately"
          @change="orderChange"
          size="small"
        >
          <el-radio label="num">按数量</el-radio>
          <el-radio label="amount">按额度</el-radio>
        </el-radio-group>
        <span class="form-tip">默认近七天</span>
        <ve-line :data="chartData"></ve-line>
      </div>
    </div>
  </hm-content>
</template>

<script>
import VeLine from "v-charts/lib/line.common";
import { mapGetters } from "vuex";
export default {
  components: {
    VeLine
  },
  data() {
    return {
      chartData: {
        columns: ["calDate", "推订单", "销量申报"],
        rows: [
          // { 日期: "1月1日", 推订单: 123, 销量申报: 123 },
          // { 日期: "1月2日", 推订单: 1223, 销量申报: 123 },
          // { 日期: "1月3日", 推订单: 2123, 销量申报: 123 },
          // { 日期: "1月4日", 推订单: 4123, 销量申报: 123 },
          // { 日期: "1月5日", 推订单: 3123, 销量申报: 123 },
          // { 日期: "1月6日", 推订单: 7123, 销量申报: 123 }
        ]
      },

      applyDateMark: [],
      applyDatesSend: [],
      applyDatesPacket: [],
      // currentPage: 1,
      // pageSize: 10,
      useImmediately: "num"
    };
  },
  computed: mapGetters([
    "marketingDynamic",
    "auditDynamic",
    "sendRankingList",
    "redpacket"
  ]),
  watch: {},
  created() {},
  mounted() {
    this.queryMarketingDynamic();
    this.$store.dispatch("queryAuditDynamic");
    this.querySendRanking();
    this.queryRedPacketTendency();
  },
  methods: {
    searchMark() {
      this.queryMarketingDynamic();
    },
    searchSend() {
      this.currentPage = 1;
      this.querySendRanking();
    },
    search() {
      this.queryRedPacketTendency();
    },
    orderChange(val) {
      this.queryRedPacketTendency();
    },
    queryMarketingDynamic() {
      let params = {
        startDateTime:
          this.applyDateMark && this.applyDateMark.length > 0
            ? this.applyDateMark[0]
            : "",
        endDateTime:
          this.applyDateMark && this.applyDateMark.length > 0
            ? this.applyDateMark[1]
            : ""
      };

      return this.$store.dispatch("queryMarketingDynamic", params);
    },
    querySendRanking() {
      let params = {
        // pageSize: this.pageSize,
        // pageNo: this.currentPage,
        startDateTime:
          this.applyDatesSend && this.applyDatesSend.length > 0
            ? this.applyDatesSend[0]
            : "",
        endDateTime:
          this.applyDatesSend && this.applyDatesSend.length > 0
            ? this.applyDatesSend[1]
            : ""
      };

      return this.$store.dispatch("querySendRanking", params);
    },
    queryRedPacketTendency() {
      let params = {
        startDateTime:
          this.applyDatesPacket && this.applyDatesPacket.length > 0
            ? this.applyDatesPacket[0]
            : "",
        endDateTime:
          this.applyDatesPacket && this.applyDatesPacket.length > 0
            ? this.applyDatesPacket[1]
            : "",
        queryState: this.useImmediately
      };

      return this.$store
        .dispatch("queryRedPacketTendency", params)
        .then(res => {
          if (res.code === "0") {
            res.result.forEach(v => {
              v.推订单 = v.billCount;
              v.销量申报 = v.shareCount;
            });
            this.chartData.rows = res.result;
          }
        });
    },
    paging(page) {
      this.currentPage = page;
      this.querySendRanking();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.querySendRanking();
    },
    billWaitAuditCount(declareVersion) {
      this.$router.push({
        name: "SalesVolume",
        query: {
          declareVersion: declareVersion
        }
      });
    },
    brandGuiderWaitAuditCount() {
      this.$router.push({
        name: "BrandJoinAudit"
      });
    },
    guiderGetcashRecordWaitAuditCount() {
      this.$router.push({
        name: "Withdraw"
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.table {
  padding: 0 20px 0 0;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  padding: 10px;
  background: rgba(247, 247, 247, 1);
  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.1);
  position: relative;
  .ccc {
    text-align: center;
  }
  .pp20 {
    padding: 20px 0;
  }
  img {
    width: 80px;
  }
  .tit {
    font-size: 16px;
    font-weight: 600;
    font-family: Microsoft YaHei;
    overflow: hidden;
    white-space: nowrap;
  }
  .titval {
    font-size: 24px;
    font-weight: bold;
  }
}
.xiaoliang {
  background: linear-gradient(
    -90deg,
    rgba(173, 193, 251, 1),
    rgba(77, 119, 255, 1)
  );
}
.quanshen {
  background: linear-gradient(-90deg, #FCBC8A, #F78752);
}
.daogou {
  background: linear-gradient(
    90deg,
    rgba(255, 88, 101, 1),
    rgba(247, 181, 186, 1)
  );
}
.tixian {
  background: linear-gradient(
    270deg,
    rgba(215, 180, 250, 1),
    rgba(178, 77, 255, 1)
  );
}
.grid-contents {
  border-radius: 6px;
  padding: 30px 0 30px 50px;
  img {
    width: 70px;
  }

  .tit {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
  }
  .titval {
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 400;
    margin-top: 10px;
  }
}
</style>
